import { DateTime } from 'luxon';
import { pluralise } from './form-utils';

function ApplyOrder(items) {
    const orderedCollection = [];
    let unsortedItems = [];
    for (let i = 0; i < items.length; i += 1) {
        const currentItem = items[i];
        currentItem.order = i + 1;
        if (!items[i].Reply && unsortedItems.length < 1) {
            unsortedItems.push(items[i]);
        } else if (!items[i].Reply && unsortedItems.length > 0) {
            currentItem.order = unsortedItems[0].order;
            unsortedItems = [];
        }

        orderedCollection.push(items[i]);
    }

    return orderedCollection;
}

function GetPageUrl(groupPath, appealUrl) {
    if (groupPath) {
        const pageUrl = new URL(appealUrl);

        let path = pageUrl.pathname;
        if (path.endsWith('/')) {
            path = path.substring(0, path.lastIndexOf('/'));
        }

        pageUrl.pathname = `${path}/${groupPath}`;

        return pageUrl.toString();
    }

    return appealUrl;
}

function GetTargetInfo(targetKey, appealList, defaultInfo) {
    const target = appealList.find((a) => a.TargetKey === targetKey);
    if (target) {
        return target;
    }

    // if we can't find the pageUrl return the default appealinfo
    return defaultInfo;
}

const HARDCODE_TARGETNAME_CHARITIES = [
    'charity-uehbBcnQ', //alias Sarang LOCAL charity key
    'charity-WBqbWtje', //Blueball Foundation TEST charity key
    'charity-vd0QienH', //Foodbank Victoria PROD charity key 
]

function GetTargetName(charitykey, targetName, appealTitle) {
    if (HARDCODE_TARGETNAME_CHARITIES.includes(charitykey)) {
        return 'Foodbank Victoria'
    }

    if (targetName) {
        return targetName;
    }

    return appealTitle;
}

function getAbsoluteDate(t) {
    return `${(`${t.day}`)}-${(`${t.month}`)}-${t.year}`
}

function CalculateTimeDiff(from, isOnlyRelativeToDay, to = DateTime.local(), format = 'SHORT') {
    if (!from || !from.trim())  {
        return '';
    }

    const createdTime = DateTime.fromISO(from.trim());

    const { years, months, days, hours, minutes } = to.diff(createdTime, ['years', 'months', 'days', 'hours', 'minutes']).toObject();

    const diffMinutes = Math.floor(minutes);

    let timeSpanResult = '';

    if (isOnlyRelativeToDay && years > 0) {
        timeSpanResult = getAbsoluteDate(createdTime);
    } else if (years > 0) {
        timeSpanResult = `${years} ${pluralise(years, format === 'SHORT' ? 'yr' : 'year')} ago`;
    } else if (isOnlyRelativeToDay && months > 0) {
        timeSpanResult = getAbsoluteDate(createdTime);
    } else if (months > 0) {
        timeSpanResult = `${months} ${pluralise(months, format === 'SHORT' ? 'mth' : 'month')} ago`;
    } else if (isOnlyRelativeToDay && days > 1) {
        timeSpanResult = getAbsoluteDate(createdTime);
    } else if (days > 0) {
        timeSpanResult = `${days} ${pluralise(days, 'day')} ago`;
    } else if (hours > 0) {
        timeSpanResult = `${hours} ${pluralise(hours, format === 'SHORT' ? 'hr' : 'hour')} ago`;
    } else if (diffMinutes > 0) {
        timeSpanResult = `${diffMinutes} ${pluralise(diffMinutes, format === 'SHORT' ? 'min' : 'minute')} ago`;
    } else {
        timeSpanResult = 'now';
    }

    return timeSpanResult;
}

function GetNestedComments(charityKey, commentEntries, appealName) {
    // replyDict is dictionary for reply message
    // e.g.:{msg-5omQuzXP: {Key: "msg-K3GYPgJT",Author:...}}
    const replyDict = {};
    commentEntries.forEach((c) => {
        if (c.Parent) {
            replyDict[c.Parent] = c;
        }
    });

    // commentList just include those comment without parent
    const commentList = commentEntries.filter((comment) => !comment.Parent);

    const resultList = commentList.map((comment) => {
        // if comment.Key in reply, append nested object as Reply
        // then add new object to resultList
        if (comment.Key in replyDict) {
            const result = comment;
            result.Reply = {
                MessageText: replyDict[comment.Key].MessageText,
                Author: replyDict[comment.Key].Author,
                TargetKey: replyDict[comment.Key].TargetKey,
                TargetName: GetTargetName(charityKey, comment.TargetName, appealName),
                CommentKey: replyDict[comment.Key].Key,
                ParentCommentKey: comment.Key,
                Created: replyDict[comment.Key].Created,
            };
            return result;
        }
        return comment;
    });
    return resultList;
}

const SortOrders = {
    Oldest: {
        Key: 'oldest',
        Value: 'Oldest',
    },
    Newest: {
        Key: 'newest',
        Value: 'Newest',
    },
    LowestAmount: {
        Key: 'lowestAmount',
        Value: 'Lowest Amount',
    },
    HighestAmount: {
        Key: 'highestAmount',
        Value: 'Highest Amount',
    },
};

function GetOrderByQuery(sortOrder) {
    switch (sortOrder) {
        case SortOrders.Oldest.Key:
            return 'Created';
        case SortOrders.LowestAmount.Key:
            return 'Amount';
        case SortOrders.HighestAmount.Key:
            return 'Amount desc';
        case SortOrders.Newest.Key:
        default:
            return 'Created desc';
    }
}

function SortComments(tempCommentsList, sortOrder) {
    let commentsToSort = [];
    switch (sortOrder) {
        case SortOrders.Oldest.Key:
            commentsToSort = tempCommentsList.sort((a, b) => (a.Created > b.Created ? 1 : -1));
            break;
        case SortOrders.LowestAmount.Key:
            commentsToSort = tempCommentsList.sort((a, b) => (a.Amount > b.Amount ? 1 : -1));
            break;
        case SortOrders.HighestAmount.Key:
            commentsToSort = tempCommentsList.sort((a, b) => (a.Amount > b.Amount ? -1 : 1));
            break;
        case SortOrders.Newest.Key:
        default:
            commentsToSort = tempCommentsList.sort((a, b) => (a.Created > b.Created ? -1 : 1));
    }

    return commentsToSort;
}

export default {
    ApplyOrder,
    GetPageUrl,
    GetTargetName,
    CalculateTimeDiff,
    GetNestedComments,
    GetTargetInfo,
    SortComments,
    SortOrders,
    GetOrderByQuery,
};
